import * as dat from 'lil-gui'
import * as THREE from 'three'
import { OrbitControls } from 'three/examples/jsm/controls/OrbitControls.js'
import { GLTFLoader } from 'three/examples/jsm/loaders/GLTFLoader.js'
import fireFliesVertexShader from "./shaders/fireFlies/fireFliesVertex.glsl"
import fireFliesFragmentShader from "./shaders/fireFlies/fireFliesFragment.glsl"
import kabushVertexShader from "./shaders/kabush/kabushVertex.glsl"
import kabushFragmentShader from "./shaders/kabush/kabushFragment.glsl"
import portalVertexShader from "./shaders/portal/portalVertex.glsl"
import portalFragmentShader from "./shaders/portal/portalFragment.glsl"




/**
 * Base
 */
// Debug
const debugObject = {
    clearColor              : "#201919",
    portalColorStart        : "#7a7ae6",
    portalColorEnd          : "#444497",
    perlinNoiseStrength1    : 11.75,
    perlinNoiseStrength2    : 1.8,
    perlinNoiseTime1        : 1.376,
    perlinNoiseTime2        : 0.60,
    outherGlowStrength      : 12.5,
    outherGlowLimit         : 3.77,
    animationDelay          : 0.6,
    animationSpeed          : 0.1,
    colorWaveTime           : 1.2,
    colorWaveAmplitude      : 0.5
};

const gui = new dat.GUI({
    width: 300
})

// Canvas
const canvas = document.querySelector('canvas.webgl')

// Scene
const scene = new THREE.Scene()

/**
 * Loaders
 */
// Texture loader
const textureLoader = new THREE.TextureLoader()

// Draco loader
//const dracoLoader = new DRACOLoader()
//dracoLoader.setDecoderPath('draco/')

// GLTF loader
const gltfLoader = new GLTFLoader()
//gltfLoader.setDRACOLoader(dracoLoader)

/**
 * Textures
 */
let tween = null;
let tween2 = null;
const bakedTexture = textureLoader.load('portal2.jpg', () => {
    console.log(portalLightMaterial.uniforms.uOutherGlowStrength.value);
/*    window.setTimeout(() => {
        AnimateGate();
    }, 1000);*/
})
bakedTexture.flipY = false
bakedTexture.encoding = THREE.sRGBEncoding


/**
 * Materials
 */
// Baked material
const bakedMaterial = new THREE.MeshBasicMaterial({ map: bakedTexture })

// Pole light material
const poleLightMaterial = new THREE.MeshBasicMaterial({ color: 0xffffe5 })

// Portal light material
const portalLightMaterial = new THREE.ShaderMaterial({ 
    uniforms        : {
        uTime                   : { value : 0.0 },
        uColorStart             : { value : new THREE.Color(debugObject.portalColorStart) },
        uColorEnd               : { value : new THREE.Color(debugObject.portalColorEnd) },
        uPerlinNoiseStrength1   : { value : debugObject.perlinNoiseStrength1 },
        uPerlinNoiseStrength2   : { value : debugObject.perlinNoiseStrength2 },
        uPerlinNoiseTime1       : { value : debugObject.perlinNoiseTime1 },
        uPerlinNoiseTime2       : { value : debugObject.perlinNoiseTime2 },
        uOutherGlowStrength     : { value : debugObject.outherGlowStrength },
        uOutherGlowLimit        : { value : debugObject.outherGlowLimit },
        uAnimationDelay         : { value : debugObject.animationDelay },
        uAnimationSpeed         : { value : debugObject.animationSpeed },

        uColorWaveTime          : { value : debugObject.colorWaveTime },
        uColorWaveAmplitude     : { value : debugObject.colorWaveAmplitude }
    },
    side            : THREE.DoubleSide,
    vertexShader    : portalVertexShader,
    fragmentShader  : portalFragmentShader, 
    transparent     : true
    
})


const debugPortal = gui.addFolder("Portal")
gui.open(false)

debugPortal.addColor(debugObject, 'portalColorStart').onChange(() => {
    portalLightMaterial.uniforms.uColorStart.value.set(debugObject.portalColorStart);
})
debugPortal.addColor(debugObject, 'portalColorEnd').onChange(() => {
    portalLightMaterial.uniforms.uColorEnd.value.set(debugObject.portalColorEnd);
})

debugPortal.add(debugObject, 'perlinNoiseStrength1').min(0.1).max(10).step(0.01).onChange(() => {
    portalLightMaterial.uniforms.uPerlinNoiseStrength1.value = debugObject.perlinNoiseStrength1;
});

debugPortal.add(debugObject, 'perlinNoiseStrength2').min(0.1).max(10).step(0.01).onChange(() => {
    portalLightMaterial.uniforms.uPerlinNoiseStrength2.value = debugObject.perlinNoiseStrength2;
});

debugPortal.add(debugObject, 'perlinNoiseTime1').min(0.01).max(1).step(0.001).onChange(() => {
    portalLightMaterial.uniforms.uPerlinNoiseTime1.value = debugObject.perlinNoiseTime1;
});

debugPortal.add(debugObject, 'perlinNoiseTime2').min(0.01).max(1).step(0.001).onChange(() => {
    portalLightMaterial.uniforms.uPerlinNoiseTime2.value = debugObject.perlinNoiseTime2;
});

debugPortal.add(debugObject, 'outherGlowStrength').min(0.1).max(300).step(0.01).onChange(() => {
    portalLightMaterial.uniforms.uOutherGlowStrength.value = debugObject.outherGlowStrength;
});

debugPortal.add(debugObject, 'outherGlowLimit').min(0.1).max(20).step(0.01).onChange(() => {
    portalLightMaterial.uniforms.uOutherGlowLimit.value = debugObject.outherGlowLimit;
});

const debugPortalShow = debugPortal.addFolder("Portal show animation")
debugPortalShow.add(debugObject, 'animationDelay').min(0).max(3).step(0.01).onChange(() => {
    portalLightMaterial.uniforms.uAnimationDelay.value = debugObject.animationDelay;
    kabushMaretial.uniforms.uAnimationDelay.value = debugObject.animationDelay;
});

debugPortalShow.add(debugObject, 'animationSpeed').min(0.1).max(10).step(0.01).onChange(() => {
    portalLightMaterial.uniforms.uAnimationSpeed.value = debugObject.animationSpeed;
    kabushMaretial.uniforms.uAnimationSpeed.value = debugObject.animationSpeed;
});


const animateButton = { animate : () => { 
    portalLightMaterial.uniforms.uTime.value = 0; 
    kabushMaretial.uniforms.uTime.value = 0; 
}}
debugPortalShow.add(animateButton, 'animate').name("Animate StarGate");
const debugPortalWaves = debugPortal.addFolder("Portal waves animation")

debugPortalWaves.add(debugObject, 'colorWaveTime').min(0.1).max(10).step(0.01).onChange(() => {
    portalLightMaterial.uniforms.uColorWaveTime.value = debugObject.colorWaveTime;
});

debugPortalWaves.add(debugObject, 'colorWaveAmplitude').min(0.1).max(2).step(0.01).onChange(() => {
    portalLightMaterial.uniforms.uColorWaveAmplitude.value = debugObject.colorWaveAmplitude;
});





/**
 * Model
 */
let portalLightMesh = {}
gltfLoader.load(
    'portal2.glb',
    (gltf) => {
        scene.add(gltf.scene)

        // Get each object
        const bakedMesh = gltf.scene.children.find((child) => child.name === 'baked')
        portalLightMesh = gltf.scene.children.find((child) => child.name === 'portalLight')
        const poleLightAMesh = gltf.scene.children.find((child) => child.name === 'poleLightA')
        const poleLightBMesh = gltf.scene.children.find((child) => child.name === 'poleLightB')

        // Apply materials
        bakedMesh.material = bakedMaterial
        portalLightMesh.material = portalLightMaterial
        poleLightAMesh.material = poleLightMaterial
        poleLightBMesh.material = poleLightMaterial

        setupKabush();
    }
)

/**
 * FireFlies
 */
const fireFliesGeometry      = new THREE.BufferGeometry();
const fireFlyesCount         = 30;
const fireFlyesPositionArray = new Float32Array(fireFlyesCount * 3);
const fireFlyesScaleArray    = new Float32Array(fireFlyesCount);

for (let i = 0; i < fireFlyesCount; i++) {
    fireFlyesPositionArray[i * 3 + 0] = (Math.random() - 0.5) * 4;   // from -2 to 2
    fireFlyesPositionArray[i * 3 + 1] = (Math.random() * 1.5);       // from 0 to 1.5
    fireFlyesPositionArray[i * 3 + 2] = (Math.random() - 0.5) * 3.5;   // from -1.75 to 1.75

    fireFlyesScaleArray[i] = Math.random();
}

fireFliesGeometry.setAttribute('position', new THREE.BufferAttribute(fireFlyesPositionArray, 3));
fireFliesGeometry.setAttribute('aScale', new THREE.BufferAttribute(fireFlyesScaleArray, 1));
const firefliesMaretial = new THREE.ShaderMaterial({
    transparent     : true,
    blending        : THREE.AdditiveBlending,   // Fusionate colors with the scene
    depthWrite      : false,                    // deactivate depthWrite to show objects behind
    uniforms        : {
        uTime       : { value : 0 },
        uPixelRatio : { value : Math.min(window.devicePixelRatio, 2) },
        uSize       : { value : 100 }
    },
    vertexShader    : fireFliesVertexShader,
    fragmentShader  : fireFliesFragmentShader
});

gui.add(firefliesMaretial.uniforms.uSize, 'value').min(0.0).max(500).step(1).name('fireFliesSize');
// Points
const fireFlies = new THREE.Points(fireFliesGeometry, firefliesMaretial);
scene.add(fireFlies);

const kabushMaretial = new THREE.ShaderMaterial({
    transparent     : true,
    blending        : THREE.AdditiveBlending,   // Fusionate colors with the scene
    depthWrite      : false,                    // deactivate depthWrite to show objects behind
    uniforms        : {
        uTime       : { value : 0 },
        uColorStart             : { value : new THREE.Color(debugObject.portalColorStart) },
        uColorEnd               : { value : new THREE.Color(debugObject.portalColorEnd) },
        uPixelRatio             : { value : Math.min(window.devicePixelRatio, 2) },
        uSize                   : { value : 50 },
        uAnimationDelay         : { value : debugObject.animationDelay },
        uAnimationSpeed         : { value : debugObject.animationSpeed },

    },
    vertexShader    : kabushVertexShader,
    fragmentShader  : kabushFragmentShader
});


function setupKabush() {
    /**
     * Kabush (particles for portal open animation)
     */
    const kabushGeometry      = new THREE.BufferGeometry();
    const kabushCount         = 2000;
    const kabushPositionArray = new Float32Array(kabushCount * 3);
    const kabushScaleArray    = new Float32Array(kabushCount);
    const kabushAngleArray    = new Float32Array(kabushCount);
    const kabushRadiusArray   = new Float32Array(kabushCount);
    const kabushRandArray     = new Float32Array(kabushCount);

    for (let i = 0; i < kabushCount; i++) {
        const angle  = Math.random() * 360;
        const radius = 0.1 + (Math.random() * 0.5);
        
        kabushPositionArray[i * 3 + 0] = portalLightMesh.position.x + (Math.cos(angle) * radius)
        kabushPositionArray[i * 3 + 1] = portalLightMesh.position.y + (Math.sin(angle) * radius);
        kabushPositionArray[i * 3 + 2] = (portalLightMesh.position.z + 0.05) - (radius * 0.5)  // from -1.75 to 1.75

        kabushScaleArray[i]  = Math.random();        
        kabushRandArray[i]   = Math.random();
        kabushAngleArray[i]  = angle;
        kabushRadiusArray[i] = radius;
    }

    kabushGeometry.setAttribute('position', new THREE.BufferAttribute(kabushPositionArray, 3));
    kabushGeometry.setAttribute('aScale',   new THREE.BufferAttribute(kabushScaleArray, 1));
    kabushGeometry.setAttribute('aRand',    new THREE.BufferAttribute(kabushRandArray, 1));
    kabushGeometry.setAttribute('aAngle',   new THREE.BufferAttribute(kabushAngleArray, 1));
    kabushGeometry.setAttribute('aRadius',  new THREE.BufferAttribute(kabushRadiusArray, 1));
    
    
    // Points
    const kabush = new THREE.Points(kabushGeometry, kabushMaretial);
    console.log(kabush)
    scene.add(kabush);
}



/**
 * Sizes
 */
const sizes = {
    width: window.innerWidth,
    height: window.innerHeight
}

window.addEventListener('resize', () => {
    // Update sizes
    sizes.width = window.innerWidth
    sizes.height = window.innerHeight

    // Update camera
    camera.aspect = sizes.width / sizes.height
    camera.updateProjectionMatrix()

    // Update renderer
    renderer.setSize(sizes.width, sizes.height)
    renderer.setPixelRatio(Math.min(window.devicePixelRatio, 2))

    // Update fireFlies pixel ratio
    firefliesMaretial.uniforms.uPixelRatio.value = Math.min(window.devicePixelRatio, 2);
    firefliesMaretial.uniforms.uPixelRatio.value = Math.min(window.devicePixelRatio, 2);
    if (typeof(kabushMaretial.uniforms) !== "undefined") {
        kabushMaretial.uniforms.uPixelRatio.value = Math.min(window.devicePixelRatio, 2);
        kabushMaretial.uniforms.uPixelRatio.value = Math.min(window.devicePixelRatio, 2);    
    }
})

/**
 * Camera
 */
// Base camera
const camera = new THREE.PerspectiveCamera(45, sizes.width / sizes.height, 0.1, 100)
camera.position.x = 4
camera.position.y = 2
camera.position.z = 4
scene.add(camera)

// Controls
const controls = new OrbitControls(camera, canvas)
controls.enableDamping = true
// Limit the view angle to avoid position the camera under the ground
controls.maxPolarAngle = Math.PI / 2 - 0.1;

/**
 * Renderer
 */
const renderer = new THREE.WebGLRenderer({
    canvas: canvas,
    antialias: true
})
renderer.outputEncoding = THREE.sRGBEncoding
renderer.setSize(sizes.width, sizes.height)
renderer.setPixelRatio(Math.min(window.devicePixelRatio, 2))
renderer.setClearColor(debugObject.clearColor);
gui.addColor(debugObject, 'clearColor').onChange(() => { 
    renderer.setClearColor(debugObject.clearColor); 
})

/**
 * Animate
 */
const clock = new THREE.Clock()
let previousTime = 0

const tick = () => {
    const elapsedTime   = clock.getElapsedTime()
    const deltaTime     = elapsedTime - previousTime;
    previousTime        = elapsedTime;

    // update shader times
    firefliesMaretial.uniforms.uTime.value += deltaTime;
    portalLightMaterial.uniforms.uTime.value += deltaTime;
    if (typeof(kabushMaretial.uniforms) !== "undefined") {
        kabushMaretial.uniforms.uTime.value += deltaTime;
    }

    // Update controls
    controls.update()

    // Render
    renderer.render(scene, camera)

    // Call tick again on the next frame
    window.requestAnimationFrame(tick)
}

tick()